<template>
	<div ref="scrollParent">
		<div ref="scroll">
			<slot></slot>
		</div>	
	</div>
</template>
​
<script>
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
export default {
	mounted() {
		this.scroll();
	},
    props: {
        to: {
        	default: false
        },
        from: {
        	default: false
        },
        enableOnMobile: {
        	default: false
        }
    },
    methods: {
    	scroll() {
    		const wHeight = window.innerHeight;
            
            gsap.to(this.$refs.scrollParent, {
                scrollTrigger: {
                trigger: this.$refs.scroll, // start the animation when ".box" enters the viewport (once)
                endTrigger: '.site-footer',
                scrub: 0,
                start: 'start 0%',
                end: 'bottom 100%',
                //markers: true
                //pin: true, 
                },
                y: this.to ? this.to : 100
            });
    	}
    }
}
</script>